/* This file is auto-generated. Do not edit manually. */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols

import * as React from 'react'
import { lazy, Suspense } from 'react'
import cx from 'classnames'
import styles from './SpotIllustration.module.css'

// prettier-ignore
function Placeholder({ className, label }: { className?: string, label?: string }) {
  return <svg viewBox="0 0 280 200" width="100%" className={className} {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })} />
}

// The artwork is decorative, so a chunk that fails to load (a flaky network,
// or a deploy that replaced it) leaves the empty box rather than failing the
// page.
const JobNoLongerAvailableArtwork = lazy(() =>
  import('./refresh/JobNoLongerAvailableArtwork').catch(() => ({ default: Placeholder })),
)

/**
 * Illustration for `job-no-longer-available`, sized by `className`.
 */
// prettier-ignore
export default function JobNoLongerAvailableIllustration({ className, label }: { className?: string, label?: string }) {
  const svgClassName = cx(styles.fitted, className)
  return (
    <Suspense fallback={<Placeholder className={svgClassName} label={label} />}>
      <JobNoLongerAvailableArtwork className={svgClassName} label={label} />
    </Suspense>
  )
}
